import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDWjQ-11B_J6-8vstvEf4ldtBv5mZw_d3o",
  authDomain: "mehfooz-mustaqbil-foundation.firebaseapp.com",
  projectId: "mehfooz-mustaqbil-foundation",
  storageBucket: "mehfooz-mustaqbil-foundation.appspot.com",
  messagingSenderId: "707264425145",
  appId: "1:707264425145:web:542e78ea88602888683f68",
  measurementId: "G-GPNZQW3TY0",
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export { app, firestore };
